var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-autocomplete',_vm._g(_vm._b({attrs:{"label":_vm.$attrs.label || 'Loja',"items":_setup.lojasFiltradas,"loading":_setup.carregando || _vm.$attrs.loading,"value":_vm.value},on:{"click:clear":() => _vm.$nextTick(() => _vm.$emit('input', null))}},'v-autocomplete',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }